import { object, string } from 'yup'
import { barcodeFormatOptions } from './common'
import { t } from 'translations'

// Messages are functions so they are translated when validation runs, not when this module loads.

export const validationSchema = object({
    barcodePoolName: string().max(255).required(() => t('venue.bookingCodes.barcodePools.validation.nameRequired')),
    barcodePrefix: string()
        .max(8)
        .when('barcodeFormatOption', (barcodeFormatOption, schema) => {
            if (barcodeFormatOption?.allowPrefix) {
                switch (barcodeFormatOption?.type) {
                    case 'qr_code':
                        return schema.matches(
                            /^[\u0020-\u00FF]*$/,
                            () => t('venue.bookingCodes.barcodePools.validation.qrCodePrefix'),
                        )
                    case 'code128':
                        return schema.matches(
                            /^[\u0020-\u007E]*$/,
                            () => t('venue.bookingCodes.barcodePools.validation.code128Prefix'),
                        )
                    case 'code39':
                        return schema.matches(
                            /^[0-9A-Z\w$%*+\-.\/]*$/,
                            () => t('venue.bookingCodes.barcodePools.validation.code39Prefix'),
                        )
                    default:
                        return schema.length(0, () => t('venue.bookingCodes.barcodePools.validation.prefixNotAllowed'))
                }
            }
            return schema.length(0, () => t('venue.bookingCodes.barcodePools.validation.prefixNotAllowed'))
        }),
    barcodeFormatOption: object({
        type: string().when('poolTypeOption', {
            is: 'Generated',
            then: string().oneOf(
                barcodeFormatOptions
                    .filter(({ value: { allowGenerated } }) => allowGenerated)
                    .map(({ value: { type } }) => type),
                () => t('venue.bookingCodes.barcodePools.validation.formatNotAllowedForGenerated'),
            ),
            otherwise: string().required(() => t('venue.bookingCodes.barcodePools.validation.formatRequired')),
        }),
    })
        .nullable()
        .required(() => t('venue.bookingCodes.barcodePools.validation.formatRequired')),
    poolTypeOption: string()
        .when('barcodeFormatOption', (barcodeFormatOption, schema) =>
            barcodeFormatOption?.type === 'ean8'
                ? schema.oneOf(['Uploaded'], () => t('venue.bookingCodes.barcodePools.validation.ean8MustBeUploaded'))
                : schema,
        )
        .nullable()
        .required(() => t('venue.bookingCodes.barcodePools.validation.poolTypeRequired')),
})
